import { useTranslation } from 'react-i18next'
import FullnessBarChart from '../../chart-molecules/fullness-molecules/FullnessBarChart'
import FullnessDoughnut from '../../chart-molecules/fullness-molecules/FullnessDoughnut'
import FullnessStackedChart from '../../chart-molecules/fullness-molecules/FullnessStackedChart'

const FullnessContainer = (props: {
  tabIndex: number
  icon: any
  detailTitle: string
  colors: string[]
  detailFooter: string
  response: any
  userInfo: any
}) => {
  const { t } = useTranslation()
  return (
    <div className="row">
      <div className="col-3 d-flex flex-column">
        <FullnessDoughnut
          icon={props.icon}
          response={props.response}
          detailTitle={props.detailTitle}
          labels={[t('dashboard.num-of-coming-office'), t('dashboard.num-of-not-coming-office')]}
          colors={props.colors}
          detailFooter={props.detailFooter}
          userInfo={props.userInfo}
          tabIndex={props.tabIndex}
        />
      </div>

      {props.tabIndex === 4 ? (
        <div className="col-9">
          <FullnessBarChart colors={props.colors} response={props.response} userInfo={props.userInfo} />
        </div>
      ) : (
        <div className="col-9">
          <FullnessStackedChart response={props.response} colors={props.colors} userInfo={props.userInfo} />
        </div>
      )}
    </div>
  )
}

export default FullnessContainer
